export default __webpack_public_path__ + "static/media/02.768e814e.jpg";